import e, { forwardRef as l } from "react";
import { PlainIconButton as a } from "./button/plain-icon-button.esm.js";
import i from "./icon/src/ArrowBack.esm.js";
import m from "./icon/src/Close.esm.js";
import { TypographyComponent as p } from "./typography/typography-component.esm.js";
import "./typography/typography-config.esm.js";
const u = "_drawer_1lpxc_1", f = "_drawer__contentContainer_1lpxc_42", b = "_drawer__body_1lpxc_57", h = "_drawer__stickyDrawer_1lpxc_65", y = "_drawer__promotionalArea_1lpxc_69", x = "_drawer__content_1lpxc_42", g = "_drawer__header_1lpxc_85", k = "_drawer__iconButton_1lpxc_115", B = "_drawer__heading_1lpxc_123", r = {
  drawer: u,
  drawer__contentContainer: f,
  drawer__body: b,
  drawer__stickyDrawer: h,
  drawer__promotionalArea: y,
  drawer__content: x,
  drawer__header: g,
  drawer__iconButton: k,
  drawer__heading: B
}, D = l(
  ({
    title: _,
    backCallback: t = () => {
    },
    closeCallback: d = () => {
    },
    drawerHeadingId: o,
    hasBackButton: n = !1,
    srLabelBackButton: c,
    srLabelCloseButton: s
  }, w) => /* @__PURE__ */ e.createElement("div", { ref: w, className: `${r.drawer__header} fuse-drawer__header` }, n && /* @__PURE__ */ e.createElement(
    a,
    {
      className: `${r.drawer__iconButton} fuse-drawer__back-button`,
      callback: t,
      icon: /* @__PURE__ */ e.createElement(i, null),
      "data-testid": "fuse-drawer-back-button-test-id",
      srLabel: c
    }
  ), /* @__PURE__ */ e.createElement(
    p,
    {
      className: `${r.drawer__heading} fuse-drawer__heading`,
      id: o,
      "data-testid": "fuse-drawer-header-test-id",
      size: "3",
      type: "heading"
    },
    _
  ), /* @__PURE__ */ e.createElement(
    a,
    {
      className: `${r.drawer__iconButton} fuse-drawer__close-button`,
      callback: d,
      icon: /* @__PURE__ */ e.createElement(m, null),
      "data-testid": "fuse-drawer-close-button-data-test-id",
      srLabel: s
    }
  ))
);
D.displayName = "DrawerHeader";
export {
  D,
  r as s
};
